import React from 'react';
import { Dialog, DialogContent, Grid, useTheme } from '@mui/material';
import { MarketHeader, MarketQrcode } from '@market/react';

export const QR_MODAL_CONTAINER_ID = 'ar-modal';

const QrModal = (props) => {
  const theme = useTheme();

  const { url, open = false, footer, handleClose = () => {} } = props;

  try {
    // test to make sure the url is valid
    new URL(url);
  } catch {
    return null;
  }

  return (
    <Dialog
      fullWidth
      data-testid={QR_MODAL_CONTAINER_ID}
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      data-market-features="typography,html-styles"
    >
      <MarketHeader
        showNavigation
        onMarketHeaderNavigate={handleClose}
        style={{ margin: theme.spacing(4, 4, 0) }}
      />

      <DialogContent sx={{ pb: 8, px: 4 }}>
        <Grid container justifyContent="center">
          <MarketQrcode content={url} monochrome="true" />

          {footer && (
            <p
              className="paragraph-10"
              style={{ margin: theme.spacing(4, 4, 0), textAlign: 'center' }}
            >
              {footer}
            </p>
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default QrModal;
